const STATUS_COLORS: Record<string, string> = {
  draft: '#9e9e9e',
  submitted: '#1a73e8',
  pending: '#f9ab00',
  approved: '#34a853',
  accepted: '#34a853',
  rejected: '#ea4335',
};

export function getVoucherStatusColor(status: string): string {
  return STATUS_COLORS[status] ?? '#1a73e8';
}
